<template>
  <div class="offer-list mt-3">
    <Alert :alerts="errors" />
    <b-container fluid>
      <b-row>
        <b-col>
          <b-card>
            <b-row>
              <b-col md="4">
                <h3>Generierte Angebote</h3>
              </b-col>
              <b-col md="4"></b-col>
              <b-col
                md="4"
                class="text-md-right"
              >
                <OfferFilter />
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-table
                  striped
                  bordered
                  small
                  responsive
                  show-empty
                  id="my-table"
                  ref="offers"
                  :items="loadOffers"
                  :fields="fields"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :filter="filters"
                  :sort-by="sortBy"
                  :sort-desc="sortDesc"
                  :empty-text="emptyText"
                >
                  <template slot="table-busy">
                    <div class="text-center text-primary">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong> Lade Angebote...</strong>
                    </div>
                  </template>
                  <template slot="emptyfiltered">
                    <div class="text-center text-primary">
                      <strong v-if="filters && filters.filter">Keine Angebote zu "{{ filters.filter }}"
                        gefunden</strong>
                      <strong v-else>Keine Angebote vorhanden.</strong>
                    </div>
                  </template>
                  <template slot="empty">
                    <div class="text-center text-primary">
                      <strong>Keine Angebote vorhanden</strong>
                    </div>
                  </template>
                  <template v-slot:cell(authorName)="data">
                    <div
                      class="creatorimg-wrapper"
                      :id="'creator-' + data.item.id"
                    >
                      <img
                        :src="contactImg(data.item)"
                        class="creatorimg"
                      />
                    </div>
                    <b-tooltip
                      :target="'creator-' + data.item.id"
                      placement="top"
                      :title="(data.item.employee) ? data.item.employee.fullName : 'Unbekannter Mitarbeiter'"
                      triggers="hover"
                    ></b-tooltip>
                  </template>

                  <template v-slot:cell(createdAt)="data">
                    {{ formatDate(data.item.createdAt) }}
                  </template>
                  <template v-slot:cell(vcId)="data">
                    <strong
                      class="vcFilter"
                      @click="setFilters({ filter: data.item.vcId })"
                    >{{ data.item.vcId }}</strong>
                  </template>
                  <template v-slot:cell(completed)="data">
                    <b-form-checkbox
                      v-model="data.item.completed"
                      @change="setCompleted(data.item)"
                    ></b-form-checkbox>

                  </template>
                  <template v-slot:cell(views)="data">
                    <div
                      v-for="(viewedAt, index) in getViews(data.item.views)"
                      :key="index"
                    >
                      {{ formatDate(viewedAt) }}
                    </div>
                  </template>
                  <template v-slot:cell(options)="data">
                    <b-button
                      size="sm"
                      variant="secondary"
                      :disabled="data.item.completed"
                      :id="'edit-' + data.item.hash"
                      @click="openLink('/admin/offer-edit/' + data.item.hash)"
                      class="mr-1 mb-1"
                    >
                      <i class="material-icons">edit</i>
                    </b-button>
                    <b-tooltip
                      :target="'edit-' + data.item.hash"
                      placement="top"
                      title="Angebot bearbeiten"
                      triggers="hover"
                      :no-fade="true"
                      delay="0"
                      boundary="window"
                      noninteractive
                    ></b-tooltip>
                    <a
                      class="btn btn-secondary btn-sm mr-1 mb-1"
                      :href="'/offer/' + data.item.hash"
                      :id="'open-' + data.item.hash"
                      target="_blank"
                    >
                      <i class="material-icons">visibility</i>
                    </a>
                    <b-tooltip
                      :target="'open-' + data.item.hash"
                      placement="top"
                      title="Kundenansicht"
                      triggers="hover"
                      :no-fade="true"
                      delay="0"
                      boundary="window"
                      noninteractive
                    ></b-tooltip>
                    <b-button
                      size="sm"
                      variant="secondary"
                      :id="'copy-' + data.item.hash"
                      @click="copyLink('/offer/' + data.item.hash)"
                      class="mr-1 mb-1"
                    >
                      <i class="material-icons">file_copy</i>
                    </b-button>
                    <b-tooltip
                      :target="'copy-' + data.item.hash"
                      placement="top"
                      title="Link kopieren"
                      triggers="hover"
                      :no-fade="true"
                      delay="0"
                      boundary="window"
                      noninteractive
                    ></b-tooltip>
                    <a
                      :href="emailLink(data.item)"
                      :id="'mail-' + data.item.hash"
                      class="btn btn-secondary btn-sm mr-1 mb-1"
                    >
                      <i class="material-icons">email</i>
                    </a>
                    <b-tooltip
                      :target="'mail-' + data.item.hash"
                      placement="top"
                      title="E-Mail öffnen"
                      @change="onMailto(date.item)"
                      triggers="hover"
                      :no-fade="true"
                      delay="0"
                      boundary="window"
                      noninteractive
                    ></b-tooltip>
                    <b-button
                      size="sm"
                      variant="secondary"
                      :disabled="data.item.completed"
                      :id="'delete-' + data.item.hash"
                      @click="confirmAndDelete(data.item.id)"
                      class="mr-1 mb-1"
                    >
                      <i class="material-icons">delete</i>
                    </b-button>
                    <b-tooltip
                      :target="'delete-' + data.item.hash"
                      placement="top"
                      title="Angebot löschen"
                      triggers="hover"
                      :no-fade="true"
                      delay="0"
                      boundary="window"
                      noninteractive
                    ></b-tooltip>
                  </template>
                </b-table>
              </b-col>
            </b-row>
            <OfferPager />
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import moment from 'moment';
import Alert from '../components/Alert';
import OfferPager from '../components/OfferPager.vue';
import OfferFilter from '../components/OfferFilter.vue';
import Config from '../misc/Config.js';
import { mapGetters, mapActions, mapMutations } from 'vuex';


export default {
  name: 'OfferList',
  components: { Alert, OfferPager, OfferFilter },

  computed: {
    ...mapGetters([
      'offers',
      'offer',
      'filters',
      'currentPage',
      'perPage',
    ]),
    lastItem() {
      let lastItem = this.currentPage * this.perPage
      return Math.min(lastItem, this.offerCount);
    },
    alerts() {
      return this.errors;
    }
  },
  methods: {
    ...mapActions([
      'fetchOffers',
      'fetchOffer',
      'deleteOffer',
      'setCompleted',
    ]),
    ...mapMutations([
      'setSortBy',
      'setFilters'
    ]),
    async loadOffers(ctx) {
      this.setSortBy({
        field: ctx.sortBy,
        sortDesc: ctx.sortDesc,
      });
      await this.fetchOffers();
      return this.offers;
    },
    getViews(views) {
      return views.map(({ viewedAt }) => new Date(viewedAt))
        .sort((a, b) => a < b ? 1 : -1)
        .slice(0, 1);
    },
    contactImg(offer) {
      if (offer.employee) {
        return Config.GFU_API_URL.replace(/\/api$/, '') + offer.employee.imageUrl;
      }
      return '';
    },
    formatDate(d, dateOnly) {
      if (!d) {
        return d;
      }
      if (dateOnly) {
        return moment(d).format('DD.MM.YYYY');
      }
      return moment(d).format('DD.MM.YYYY HH:mm');
    },
    confirmAndDelete(id) {
      this.boxTwo = ''
      this.$bvModal.msgBoxConfirm('Wollen Sie dieses Angebot wirklick löschen?', {
        title: 'Angebot löschen',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'Ja, löschen',
        cancelTitle: 'Abbrechen',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      }).then(ok => {
        if (ok) {
          this.deleteOffer(id)
            .then(() => this.$refs.offers.refresh())
            .catch(() => this.$refs.offers.refresh())
        }
      })
    },
    openLink(link) {
      this.$router.push(link);
    },
    copyLink(link) {
      let container = this.$refs.container
      this.$copyText(Config.FALLBACK_ORIGINAL + link, container);
    },

    emailLink(offer) {

      const body = Config.FALLBACK_ORIGINAL + '/offer/' + offer.hash
      const subject = `Angebot  ${offer.seminar ? ' ' + offer.seminar.title : ''}`;
      const email = offer.contact ? offer.contact.email : null;
      // this.fetchOffer(offer.id)
      //   .then(() => console.log('offerToSend', this.offer));
      return [
        'mailto:' + email + '?',
        [
          'body=' + body,
          'subject=' + subject,
        ].join('&')
      ].join('');
    },
    /**
     * @todo: funktionierte bereits im alten system nicht; mal mit Abdul abklären ob das jetzt rein soll?!
     */
    onMailto(offer) {
      //offer.completed = true;
      //this.update(offer);
    }
  },
  mounted() {
    this.fetchOffers();
  },
  data() {
    return {
      errors: [],
      sortBy: "createdAt",
      sortDesc: true,
      emptyText: "Keine Angebote gefunen",
      fields: [
        {
          key: 'authorName',
          label: 'Ersteller',
          sortable: true
        },
        {
          key: 'createdAt',
          label: 'Angebotsdatum',
          sortable: true
        },
        {
          key: 'vcId',
          label: 'VC-ID',
          sortable: true
        },
        // {
        //   key: 'hash',
        //   label: 'Angebots-ID',
        //   sortable: true
        // },
        {
          key: 'offerNumber',
          label: 'Angebots-Nr.',
          sortable: true
        },

        {
          key: 'contact.ref_id',
          label: 'Kunden-Nr.',
          sortable: true,
          sortDirection: 'asc',
        },
        {
          key: 'contact.company.company',
          label: 'Kundenname',
          sortable: true,
          class: 'col-customer'
        },
        {
          key: 'offerTitle',
          label: 'Schulung',
          sortable: true,
          class: 'col-seminar'
        },
        {
          key: 'trainer.contact.fullName',
          label: 'Trainer',
          sortable: true
        },
        {
          key: 'completed',
          label: 'Versendet',
          sortable: true
        },
        // {
        //   key: 'views',
        //   label: 'Zuletzt geöffnet',
        //   sortable: true

        // }, 
        {
          key: 'offerType.name',
          label: 'Angebotstyp',
          sortable: true
        },
        {
          key: 'options',
          label: '',
          class: 'col-opts'
        }

      ]
    }
  }
}
</script>

<style>
.creatorimg-wrapper {
  height: 50px;
  width: 50px;
  border-radius: 50%;
  border: 3px solid #ddd;
  overflow: hidden;
  margin: auto;
  display: block;
}

.creatorimg-wrapper img {
  max-width: 100%;
}

th.col-opts,
th.col-customer,
th.col-file,
th.col-seminar {
  min-width: 140px;
}

td.col-file,
td.col-seminar {
  max-width: 250px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.container-fluid {
  max-width: 100%;
}

.text-primary {
  color: #266cb4 !important;
}

.page-item.active .page-link {
  background-color: #266cb4;
  border-color: #266cb4;
}

.custom-control-input:checked~.custom-control-label::before {
  background-color: #266cb4;
  border-color: #266cb4;
}

.page-link {
  color: #266cb4;
}

.vcFilter {
  color: #266cb4;
  cursor: pointer;
}
</style>
